module.exports = __webpack_public_path__ + "static/media/homer-hited.60ebe5a9.png";